import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InventoryTransactionsSingleReport  {
    _originalTypeClassName = "zERP.BO.InventoryTransactionsSingleReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InventoryTransactionsSingleReport.translate = translateService;
}
this.Date = null;
this.Warehouse = null;
this.Invoice = null;
this.Description = null;
this.UnitsIn = null;
this.ValueIn = null;
this.UnitsOut = null;
this.ValueOut = null;
this.Remaining = null;
this.GroupBy = null;
this.InventoryTransactionsSingleReportKey = null;
this._key = this.InventoryTransactionsSingleReportKey = 0; 
}

static translate: TranslateService;
_key: any;
Date:any;
Warehouse:any;
Invoice:any;
Description:any;
UnitsIn:any;
ValueIn:any;
UnitsOut:any;
ValueOut:any;
Remaining:any;
GroupBy:any;
private _InventoryTransactionsSingleReportKey:any;
get InventoryTransactionsSingleReportKey(): any {
    return this._InventoryTransactionsSingleReportKey;
  }
set InventoryTransactionsSingleReportKey(value: any) {
    this._InventoryTransactionsSingleReportKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InventoryTransactionsSingleReportKey == null || $this.InventoryTransactionsSingleReportKey == 0;
            }


}